import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { WarningIcon } from 'foundations-assets';
import { Select } from 'foundations-components/transitional/components/Select';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { DATE_TIME } from 'customer-data-objects/property/PropertyTypes';
import { DATE } from '../../filterQueryFormat/UnifiedEventPropertyTypes';
import { hasNewIlsTimeFiltersEnabled, hasRemoveTimezoneForDates } from '../../permissions/gates';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimezoneDropdown = ({
  conditionId,
  fieldType,
  useUTC,
  onChange,
  getIsUngated,
  timezoneOptions: timezoneOptionsProp
}) => {
  if (timezoneOptionsProp.length <= 1) {
    return null;
  }
  if (!hasNewIlsTimeFiltersEnabled(getIsUngated)) {
    return null;
  }
  const timezoneOptions = [{
    text: `${I18n.moment.portalTz().format('z')}`,
    value: 'portal'
  }, {
    text: `${I18n.moment.utc().format('z')}`,
    value: 'utc'
  }];
  const showWarningForDate = fieldType === DATE && !useUTC && !hasRemoveTimezoneForDates(getIsUngated);
  const showWarningForDateTime = fieldType === DATE_TIME && useUTC;
  const showWarningIcon = showWarningForDate || showWarningForDateTime;
  const warningIconTooltipHeadingMessage = fieldType === DATE ? 'customerDataFiltersUI.customerDataFilters.TimezoneToggle.portalTimezoneUsageWarning.title' : 'customerDataFiltersUI.customerDataFilters.TimezoneToggle.utcUsageWarning.title';
  const warningIconTooltipTitleMessage = fieldType === DATE ? 'customerDataFiltersUI.customerDataFilters.TimezoneToggle.portalTimezoneUsageWarning.description' : 'customerDataFiltersUI.customerDataFilters.TimezoneToggle.utcUsageWarning.description';
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(Select, {
      "data-test-id": `timezone-dropdown`,
      buttonUse: "transparent",
      options: timezoneOptions,
      onChange: evt => onChange(evt.target.value === 'utc'),
      value: useUTC ? 'utc' : 'portal'
    }, `timezone-dropdown-${conditionId}`), showWarningIcon && /*#__PURE__*/_jsx(Tooltip, {
      use: "longform",
      headingText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: warningIconTooltipHeadingMessage
      }),
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: warningIconTooltipTitleMessage
      }),
      children: /*#__PURE__*/_jsx(WarningIcon, {
        color: "fill-caution-default",
        size: "300"
      })
    })]
  });
};
export default TimezoneDropdown;